"use client";

import { useEffect } from "react";

export function ChunkErrorListener() {
  useEffect(() => {
    const triggerReload = () => {
      const lastReload = localStorage.getItem("last_chunk_reload");
      const now = Date.now();
      // Rate limit to prevent reload loops (e.g. if offline or server is actually down)
      if (!lastReload || now - Number.parseInt(lastReload, 10) > 10000) {
        localStorage.setItem("last_chunk_reload", now.toString());
        window.location.reload();
      }
    };

    const handleResourceError = (event: ErrorEvent) => {
      const target = event.target as HTMLElement | null;
      if (!target) return;

      const isScript = target.tagName === "SCRIPT";
      const isLink = target.tagName === "LINK" && (target as HTMLLinkElement).rel === "stylesheet";

      if (isScript || isLink) {
        const src = (target as HTMLScriptElement).src || (target as HTMLLinkElement).href;
        if (src?.includes("/_next/static/")) {
          console.warn("Chunk/Resource failed to load, triggering reload safeguard...", src);
          triggerReload();
        }
      }
    };

    const handleWindowError = (event: ErrorEvent) => {
      const error = event.error;
      if (error) {
        const isChunkError =
          error.name === "ChunkLoadError" ||
          error.message?.includes("Loading chunk") ||
          error.message?.includes("CSS chunk");

        if (isChunkError) {
          console.warn("ChunkLoadError detected, triggering reload safeguard...", error);
          triggerReload();
        }
      }
    };

    // Use capture phase to catch script/stylesheet network load failures (which do not bubble)
    window.addEventListener("error", handleResourceError, true);
    window.addEventListener("error", handleWindowError);

    return () => {
      window.removeEventListener("error", handleResourceError, true);
      window.removeEventListener("error", handleWindowError);
    };
  }, []);

  return null;
}
